import React from 'react';

import { handleAccessibilityAnchorsFocus } from 'helpers/a11yUtils';

import css from 'styles/components/common/skiplinks.scss';

const SkipLinks = ({ links }) => {
  if (links) {
    return (
      <div className={css.ariaSkipLinksContainer}>
        {Object.keys(links).map(name => {
          if (links[name]) {
            return <a key={name} onClick={event => handleAccessibilityAnchorsFocus(event, name)} href={`#${name}`}>{links[name]}</a>;
          }
        })}
      </div>
    );
  }
  return null;
};

export default SkipLinks;
